import { useEffect, useRef } from 'react';
import { trackEvent } from '../utils/analytics';

/** Dispara `evento` na primeira vez que o elemento retornado entra na tela.
 *  Só uma vez por carregamento de página: rolar para cima e para baixo de
 *  novo não deveria contar como uma segunda visualização. */
function useViewOnce(evento) {
  const ref = useRef(null);
  const disparado = useRef(false);

  useEffect(() => {
    const alvo = ref.current;
    if (!alvo || disparado.current) return undefined;

    const observador = new IntersectionObserver(
      ([entrada]) => {
        if (entrada.isIntersecting && !disparado.current) {
          disparado.current = true;
          trackEvent(evento);
          observador.disconnect();
        }
      },
      { threshold: 0.4 },
    );

    observador.observe(alvo);
    return () => observador.disconnect();
  }, [evento]);

  return ref;
}

export default useViewOnce;
